"use strict";
/**
 * @module dynamicSchemaRoute
 * @description Baasic Dynamic Schema Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Dynamic Schema Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../common");
;
var contracts_1 = require("../../core/contracts");
var DynamicSchemaRoute = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicSchemaRoute, _super);
    function DynamicSchemaRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'schemas/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'schemas/{name}/{?embed,fields}';
        _this.generateRoute = 'schemas/generate';
        _this.createRoute = 'schemas';
        _this.updateRoute = 'schemas/{id}';
        _this.deleteRoute = 'schemas/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing dynamic resource schema properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain dynamic resource schema subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the dynamic resource schema property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example dynamicSchemaRoute.find({searchQuery: '<search-phrase>'});
     **/
    DynamicSchemaRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which must be expanded with name of the previously created dynamic resource schema. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example dynamicSchemaRoute.find({name: '<schema-name>'});
     **/
    DynamicSchemaRoute.prototype.get = function (name, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, this.modelMapper.getParams(name, options, 'name'));
    };
    /**
     * Parses create route; this URI template doesn't expose any additional properties.
     * @method
     * @example dynamicSchemaRoute.generate();
     **/
    DynamicSchemaRoute.prototype.generate = function () {
        return _super.prototype.baseCreate.call(this, this.generateRoute, {});
    };
    /**
     * Parses create route; this URI template doesn't expose any additional properties.
     * @method
     * @example dynamicSchemaRoute.create(data);
     **/
    DynamicSchemaRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route.
     * @method
     * @param data A dynamic schema object used to update specified dynamic resource schema.
     * @example dynamicSchemaRoute.update(data);
     */
    DynamicSchemaRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route.
     * @method
     * @param data A dynamic schema object used to delete specified dynamic resource schema.
     */
    DynamicSchemaRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    DynamicSchemaRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], DynamicSchemaRoute);
    return DynamicSchemaRoute;
}(common_1.BaseRoute));
exports.DynamicSchemaRoute = DynamicSchemaRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 
